(async () => {
  const ref = new URLSearchParams(location.search).get('ref');

  if (ref) {
    document.cookie = `tisso_aff=${encodeURIComponent(ref)}; max-age=2592000; path=/`;
    await fetch(`${KROWN.settings.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { affiliate: ref } })
    });
    return;
  }

  const match = document.cookie.match(/(?:^|;\s*)tisso_aff=([^;]*)/);
  const code = match ? decodeURIComponent(match[1]) : '';
  if (!code) return;

  const cart = await fetch('/cart.js').then((r) => r.json());
  if (cart.attributes?.affiliate) return;

  await fetch(`${KROWN.settings.routes.cart_update_url}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { affiliate: code } })
  });
})();
